import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
import {
  UitkHeadingSizes,
  UitkHeadingTags,
  UitkTypeAlignments,
  UitkTypeHyphens,
  UitkTypeOverflows
} from "./types.js";
export function UitkHeading({
  align,
  children,
  className,
  tag,
  size,
  overflow,
  hyphens,
  style,
  ...attributes
}) {
  const Tag = tag && UitkHeadingTags.get(tag) || UitkHeadingTags.get("h3");
  const wrapperClassNames = classNames(
    align && UitkTypeAlignments.get(align),
    size && UitkHeadingSizes.get(size) || UitkHeadingSizes.get(6),
    overflow && UitkTypeOverflows.get(overflow),
    hyphens && UitkTypeHyphens.get(hyphens),
    className
  );
  return children ? /* @__PURE__ */ React.createElement(Tag, { className: wrapperClassNames, style, ...attributes }, children) : /* @__PURE__ */ React.createElement(React.Fragment, null);
}
;
UitkHeading.displayName = "UitkHeading";
